<template>
  <p ref="output"></p>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { recognition, SpeechRecognitionConfig } from "./configs";
export default defineComponent({
  name: "speechRecognition",
  computed: {
    configs(): SpeechRecognitionConfig {
      return new SpeechRecognitionConfig();
    },
    recognition(): typeof recognition {
      new recognition();
    },
  },
  beforeMount() {
    if ("webkitSpeechRecognition" in window) {
      this.configs.startRec();
    } else {
      console.log("Speech recognition does not support in this browser");
    }
  },
  mounted() {
    this.configs.recEvents();
  },
  unmounted() {
    recognition.stop();
    recognition.abort();
  },
  watch: {
    $route() {
      recognition.stop();
    },
  },
});
</script>
